// The active SOS, shared by every place that can raise or stop one (PRVSK-122).
//
// The sos_id used to live only in the open "Panic Sent!" window, so Close, a tap
// outside it or a reload dropped it, and nothing in the app could stop the SOS
// any more. It is now kept on the device until the SOS is stopped, and the
// "SOS active" bar (SosActiveBanner) offers Stop on every page. The box also
// accepts the login of whoever raised it, or an admin, so another device of the
// same person can stop it too.
import { apiFetch } from './streamApi';

const KEY = 'prvsk_sos_id';
export const SOS_CHANGED = 'prvsk:sos-changed';

const changed = () => window.dispatchEvent(new Event(SOS_CHANGED));

export function rememberSos(id) {
  try { localStorage.setItem(KEY, id); } catch { /* storage blocked — the login still works */ }
  changed();
}

export function rememberedSos() {
  try { return localStorage.getItem(KEY) || ''; } catch { return ''; }
}

export function forgetSos() {
  try { localStorage.removeItem(KEY); } catch { /* nothing to clear */ }
  changed();
}

// Stop the active SOS with this device's id if it has one, else with the login.
// → { ok: true } | { ok: false, message }
export async function stopActiveSos() {
  const res = await apiFetch('/admin/panic/stop', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sos_id: rememberedSos(), stopped_by: 'web' }),
  });
  if (res.ok) { forgetSos(); return { ok: true }; }
  const d = await res.json().catch(() => ({}));
  if (res.status === 409) {
    // Nothing is active any more — someone else stopped it.
    forgetSos();
    return { ok: false, message: 'The SOS has already been stopped.' };
  }
  if (res.status === 403) {
    return { ok: false, message: d.detail || 'This login can’t stop the SOS. The person who raised it or an admin can.' };
  }
  return { ok: false, message: 'Could not stop the SOS. Check the connection and try again.' };
}
